module.exports = __webpack_public_path__ + "static/media/card-3.4ae4eeff.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-3.jpeg
// module id = 1186
// module chunks = 0